export default __webpack_public_path__ + "static/media/Cadeado.4b52da9c.svg";